export default "__VITE_ASSET__BzNqQ9zz__"